import { DefaultValueConfig, Locale } from '@headless-workspace/config';
import { ObjectHelpers } from '@headless-workspace/utils';
import { mapURLToImage } from '../../../../client';
import { VipBrandsValue } from '../../config';
import { mapTileProduct, TileProductValue } from '../../types';
import { isProductAvailable } from '../../types/ProductStockType';
import { RecommendedProductsDTO } from './RecommendedProductsDTO';

export type TileProductAvailabilityValue = TileProductValue & {
    isAvailable: boolean;
};

export type RecommendedProductsValue = {
    id: string;
    title: string;
    cta?: {
        label: string;
        href: string;
    };
    products: TileProductAvailabilityValue[];
};

export const mapRecommendedProducts = (
    dto: RecommendedProductsDTO[],
    vipBrands: VipBrandsValue,
    locale: Locale,
    originalPriceText?: string,
): RecommendedProductsValue[] => {
    return dto.map((recommendation) => {
        const { cta } = recommendation;
        const ctaData = cta?.label && cta?.link ? { label: cta.label, href: cta.link } : undefined;

        return {
            id: recommendation.id,
            title: recommendation.title,
            cta: ctaData,
            products: recommendation.products.map((product) => ({
                ...mapTileProduct(product, vipBrands, locale, originalPriceText),
                image:
                    mapURLToImage(product.imageURL) ??
                    ObjectHelpers.createImageWithSrc(DefaultValueConfig.imagePlaceholder),
                isAvailable: isProductAvailable(product.stock),
            })),
        };
    });
};
